import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import MessageBox from "@/components/MessageBox"
import { getMessage } from "@/utils/MessageUtils"
import DateTime from "@/components/DateTime"
import UserInfo from "@/business-components/sale/UserInfo"

class ReviewPanel extends React.Component {
  static propTypes = {
    readOnly: PropTypes.bool,
    onEdit: PropTypes.func,
    onChange: PropTypes.func,
  }

  state = {
    orderApplyRecord: {},
  }

  render() {
    const { paymentOrderApplyRecord, onlineOrderApplyRecord } = this.props
    return (
      <div className="ReviewPanel">
        {this.renderPaymentOrderApplyRecord(paymentOrderApplyRecord)}
        {this.renderOnlineOrderApplyRecord(onlineOrderApplyRecord)}
      </div>
    )
  }

  renderOnlineOrderApplyRecord(onlineOrderApplyRecord) {
    if (onlineOrderApplyRecord !== null && onlineOrderApplyRecord !== undefined) {
      const { reviewerId, reviewTime, reviewComments, reviewStatus } = onlineOrderApplyRecord
      if (reviewerId !== null) {
        return (
          <div>
            <h2>上线审核信息</h2>
            <dl>
              <dt>审核状态：</dt>
              <dd>{getMessage(reviewStatus, "ReviewStatus")}</dd>
              <dt>审核人：</dt>
              <dd>
                <UserInfo userId={reviewerId} />
              </dd>
              <dt>审核时间：</dt>
              <dd>
                <DateTime dateTime={reviewTime} />
              </dd>
              {this.renderOnlineRejectReason(reviewStatus, reviewComments)}
            </dl>
          </div>
        )
      } else {
        return (
          <div>
            <h2>上线审核信息</h2>
            <dl>
              <dt>审核状态：</dt>
              <dd>待审核</dd>
            </dl>
          </div>
        )
      }
    }
  }

  renderPaymentOrderApplyRecord(paymentOrderApplyRecord) {
    if (paymentOrderApplyRecord !== null && paymentOrderApplyRecord !== undefined) {
      const { reviewerId, reviewTime, reviewRejectReason, reviewComments, reviewStatus } = paymentOrderApplyRecord
      if (reviewerId !== null) {
        return (
          <div>
            <h2>到款审核信息</h2>
            <dl>
              <dt>审核状态：</dt>
              <dd>{getMessage(reviewStatus, "ReviewStatus")}</dd>
              <dt>审核人：</dt>
              <dd>
                <UserInfo userId={reviewerId} />
              </dd>
              <dt>审核时间：</dt>
              <dd>
                <DateTime dateTime={reviewTime} />
              </dd>
              {this.renderPaymentRejectReason(reviewRejectReason, reviewComments)}
            </dl>
          </div>
        )
      } else {
        return (
          <div>
            <h2>到款审核信息</h2>
            <dl>
              <dt>审核状态：</dt>
              <dd>待审核</dd>
            </dl>
          </div>
        )
      }
    }
  }

  renderPaymentRejectReason(reviewRejectReason, reviewComments) {
    if (reviewRejectReason) {
      return (
        <div>
          <dt style={{ color: "red" }}>拒绝理由：</dt>
          <dd style={{ color: "red" }}>
            {getMessage(reviewRejectReason, "ReviewRejectReason")} {reviewComments}
          </dd>
        </div>
      )
    }
  }

  renderOnlineRejectReason(reviewStatus, reviewComments) {
    if (reviewComments && reviewStatus === "REVIEW_STATUS_REJECTED") {
      return (
        <div>
          <dt style={{ color: "red" }}>拒绝理由：</dt>
          <dd style={{ color: "red" }}>{reviewComments}</dd>
        </div>
      )
    } else if (reviewComments && reviewStatus === "REVIEW_STATUS_PASSED") {
      return (
        <div>
          <dt>备注：</dt>
          <dd>{reviewComments}</dd>
        </div>
      )
    }
  }
}

export default withApi(ReviewPanel)

ReviewPanel.contextType = MessageBox
